import * as R from "ramda";
const getArtefactTypeFromListType = (listType) => R.pipe(R.toLower, R.dropLast(1))(listType);
export {
  getArtefactTypeFromListType
};
